import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import FileUpload from "components/FileUpload/FileUploadSanction";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { removeSpecialCharFileName } from "utils/Utils";

const SanctionLetterOld = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
}) => {
  const params = useParams();
  let fileUploadComponent = useRef();
  const [record, setRecord] = useState({});
  const [preview, setPreView] = useState("");
  const [previewsigned, setPreviewsigned] = useState("");
  const [imagefile, setImagefile] = useState("");
  const [screenshotCheque, setScreenshotCheque] = useState(null);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [backFlex, setBackFlex] = useState(false);
  const [senctionPreview, setSanctionPreview]= useState('')
  const [callInProgress, setCallInProgress] = useState(false);
  const [disableGenerate, setDisableGenerate]= useState(false)
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const navigate = useNavigate();

  useEffect(() => {
    GetSanctionLetter();
  }, []);

  // cancel button function
  const handlecanceluser = () => {
    setBack();
    // props.history.go(-1);
  };
  const handleEsign = () => {
    setNext();
  };
  let interval 
  const generateSanctionLetter = async () => {
    setDisableGenerate(true)
    setCallInProgress(true)
    // GENERATE_SANCTIONLETTER
    const result = await apiHandler({
      url: endpoint.GENERATE_SANCTIONLETTER + loanApplicationId,
      authToken: authToken,
    }); setCallInProgress(false)
    // console.log('Next Response', data);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
      //setHtmlContent(HTML_DATA);
    } else {
      setPreviewsigned(result.data);
      GetSanctionLetterStatus(result.data)
      interval = setInterval(() => GetSanctionLetterStatus(result.data), 10000)
      setTimeout(() => { clearInterval(interval)}, 120000);
    }
  };

  const GetSanctionLetterStatus = async (id) => {
    //SANCTION_LETTER
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.STATUS_SANCTIONlETTER + id,
      method: "GET",
      authToken: authToken,
    });
    if(res.data === true){
      setCallInProgress(false)
      clearInterval(interval)
      GetSanctionLetter('generate');
      setDisableGenerate(false)
    }else{
      setTimeout(() => { setCallInProgress(false)}, 120000);
      setTimeout(() => { setDisableGenerate(false)}, 120000);
      
    }
  };
  const GetSanctionLetter = async (generate) => {
    setCallInProgress(true)
    //SANCTION_LETTER
    const res = await apiHandler({
      url: endpoint.SANCTION_LETTER + loanApplicationId,
      method: "GET",
      responseType: "arraybuffer",
      authToken: authToken,
    });
    setCallInProgress(false)
    // Build a URL from the file
    const blob = new Blob([new Uint8Array(res.data)], {
      type: "application/pdf",
    });
    const fileURL = URL.createObjectURL(blob);
    // window.open(fileURL);
    if(generate){
      setPreView(fileURL)
    } else if(res.data?.byteLength > 1200){
    setSanctionPreview(fileURL)
    }
  };
  const handleUpload = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (imagefile) {
      Updatesanctionletter(imagefile);
    } else {
      if (screenshotCheque) {
        setCallInProgress(true);
        const formData = new FormData();
        const fileName = removeSpecialCharFileName(screenshotCheque.name);
        formData.append("file", screenshotCheque, fileName);
        const path = await apiHandler({
          url: endpoint.FILE_UPLOAD,
          method: "POST",
          authToken: authToken,
          data: formData,
        });
        setCallInProgress(false);
        const uploadedPath = path.data;
        Updatesanctionletter(uploadedPath.name);
      } else {
        toastUpdate("Error","Upload Signed Sanction letter Before Submited", true);
      }
    }
    // setNext(); // kamal
  };
  const Updatesanctionletter = async (filename) => {
    setCallInProgress(true)
    //SANCTIONLETTER_UPDATE
    const res = await apiHandler({
      url: endpoint.SANCTIONLETTER_UPDATE,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        sanctionLetterLink: filename,
      },
    });
    setCallInProgress(false)
    //this.setState({ callInProgress: false });
    if (res?.data?.error_code && res?.data?.error_code === 403) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      toastUpdate("Success", "Update sanction Letter successfully", true);
      setBackFlex(true);
      setNext();
    }

    //  props.navigate(`/admin/document/` + params.loanApplicationId);
  };
  return (
    // <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label="Sanction Letter" />
        </Grid>
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
    {!preview ? 
     <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "center" }}
            >
              <Button onClick={() => generateSanctionLetter()} className={classes.nextButton} disabled={disableGenerate}>Generate</Button>
             {senctionPreview && <Button className={classes.nextButton1} onClick={()=> setPreView(senctionPreview)}>Preview</Button>}
       </GridItem>
 : 
 <>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
         
                  <FileUpload
                    // avatar={imagefile ? imagefile : DefaultCheque}
                    supportedMimeType={["application/pdf"]}
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    sendFile={(file) => {
                      setScreenshotCheque(file);
                      setImagefile("");
                    }}
                    ref={fileUploadComponent}
                    classes={classes}
                  />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              {preview !== "" ? (
                <iframe src={preview} width="100%" height="500px" />
              ) : (
                <div>Downloading Sanction Document</div>
              )}
            </GridItem>
            </>
           }
          </GridContainer>

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{textAlign: window.innerWidth < 360 ? "center" : "right", }}
            >

              <Button
                // style={{ margin: "5px" }}
                size="small"
                // color="info"
                className={classes.nextButton}
                disabled={callInProgress}
                onClick={(event) => handleUpload(event)}
              >
                Next
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        </Grid>
  );
};

SanctionLetterOld.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
};

export default SanctionLetterOld;